/// <reference path="/js/lib/jquery/jquery-1.9.1.js"/>
/// <reference path="/js/lib/backbone.js"/>
/// <reference path="~/js/lib/jquery/jquery.velir.js"/>
/// <reference path="BaseSelectorView.js"/>
/// <reference path="LocationSelectorView.js"/>

(function($, _) {
  var ns = window.nspace("ccc.viz.selectors");

  ns.SingleLocationSelectorView = ns.LocationSelectorView.extend({
    name: "Single Location Selector",
    el: "#single-location-selector",
    templateSelector: "#single-location-selector-template",
    propertyName: "locationId",
    propertySlugName: "locationSlug",

    onChangeUpdateModel: function() {
      var props, $option;

      props = {};

      $option = this.$("select option:selected");

      if (!$option.length) {
        return;
      }

      props[this.propertyName] = $option.val();
      props[this.propertySlugName] = $option.data("slug");

      var lastLocationName = this.model.attributes.locationSlug;
      var curLocationName = $option.text();
      if (
        curLocationName.trim().toLowerCase() !==
        lastLocationName.trim().toLowerCase()
      ) {
        // Tracks when a user selects a different location (e.g. Borough, or Community District) on the "Location Profile" page
        dataLayer.push({
          event: "BCD Clicks",
          eventCategory: "Interactive Clicks",
          eventAction: "BCD|" + curLocationName,
          eventLabel: window.location.pathname
        });
      }

      this.model.set(props);
    },

    /**
     * Returns text summarizing the currently selected options for this selector.
     */
    getDataSummaryText: function() {
      return $("select option:selected", this.$el).text();
    },

    render: function(selectorInfo) {
      // Call the base implementation
      ns.BaseSelectorView.prototype.render.call(this, selectorInfo);
    },

    updateDOM: function() {
      var modelProp;

      modelProp = this.model.get(this.propertyName);

      // Set the option corresponding to the value on the model
      $("select", this.$el).val(modelProp);
    }
  });
})(jQuery, _);
